import script from "./TrainerAcademyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerAcademyComponent.vue?vue&type=script&setup=true&lang=js"

import "./TrainerAcademyComponent.vue?vue&type=style&index=0&id=1ed245a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed245a4"]])

export default __exports__